import { z } from "zod";
import { collectNodeFieldSchema } from "./fields";

export const collectNodeSchema = z.object({
  nodeId: z.string(),
  name: z
    .string()
    .min(1, "Please enter valid name")
    .max(45, "Name should be precise and under 45 characters")
    .regex(
      /^[a-zA-Z0-9_ -]*$/,
      "Name can only contain alphanumeric characters, `-` and `_`",
    ),
  fields: z.array(collectNodeFieldSchema),
  isValid: z.boolean().default(true),
});

export type CollectNodeSchema = z.infer<typeof collectNodeSchema>;

export const defaultCollectNodeValues: CollectNodeSchema = {
  nodeId: "",
  name: "",
  fields: [],
  isValid: true,
};
